var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "container text-white" }, [
    _c("div", { staticClass: "row my-4 d-flex justify-content-center" }, [
      _c("h2", [_vm._v(_vm._s(_vm.$t("index.ourProjects")))]),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "row" }, [
      _c("div", { staticClass: "col-sm-4" }, [
        _c("h3", [
          _c(
            "a",
            { staticClass: "text-white", attrs: { href: _vm.kumirPath } },
            [_c("strong", [_vm._v(_vm._s(_vm.$t("index.kumir")))])]
          ),
        ]),
        _vm._v(" "),
        _c("p", [
          _vm._v(
            "\n                " +
              _vm._s(_vm.$t("index.kumirDescription[0]")) +
              "\n                " +
              _vm._s(_vm.$t("index.kumirDescription[1]")) +
              "\n                " +
              _vm._s(_vm.$t("index.kumirDescription[2]")) +
              "\n                " +
              _vm._s(_vm.$t("index.kumirDescription[3]")) +
              "\n            "
          ),
        ]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "col-sm-4" }, [
        _c("h3", [
          _c(
            "a",
            { staticClass: "text-white", attrs: { href: _vm.piktomirPath } },
            [_c("strong", [_vm._v(_vm._s(_vm.$t("index.piktomir")))])]
          ),
        ]),
        _vm._v(" "),
        _c("p", [
          _vm._v(
            "\n                " +
              _vm._s(_vm.$t("index.piktomirDescription[0]")) +
              "\n                " +
              _vm._s(_vm.$t("index.piktomirDescription[1]")) +
              "\n                " +
              _vm._s(_vm.$t("index.piktomirDescription[2]")) +
              "\n                " +
              _vm._s(_vm.$t("index.piktomirDescription[3]")) +
              "\n            "
          ),
        ]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "col-sm-4" }, [
        _c("h3", [
          _c(
            "a",
            { staticClass: "text-white", attrs: { href: _vm.mireraPath } },
            [_c("strong", [_vm._v(_vm._s(_vm.$t("index.mirera")))])]
          ),
        ]),
        _vm._v(" "),
        _c("p", [
          _vm._v(
            "\n                " +
              _vm._s(_vm.$t("index.mireraDescription[0]")) +
              "\n                " +
              _vm._s(_vm.$t("index.mireraDescription[1]")) +
              "\n            "
          ),
        ]),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }